import React from "react";

const baseButtonStyle = {
  border: "1px solid color-mix(in srgb, var(--primaryColor) 35%, transparent)",
  background: "#ffffff",
  color: "var(--primaryColor)",
  borderRadius: "999px",
  padding: "8px 14px",
  fontSize: "14px",
  fontWeight: 600,
  cursor: "pointer",
  transition: "all 0.2s ease",
};

function getTotalLabel(total) {
  if (!Number.isFinite(total) || total <= 0) {
    return null;
  }

  return `${total} เกม`;
}

const GamePaginationControls = ({ pagination, disabled, onPageChange }) => {
  const currentPage = Number(pagination?.page || 1);
  const totalPages = Number(
    pagination?.totalPages || (pagination?.hasNextPage ? currentPage + 1 : 1),
  );
  const hasPreviousPage = Boolean(
    pagination?.hasPreviousPage || currentPage > 1,
  );
  const hasNextPage = Boolean(pagination?.hasNextPage);
  const totalLabel = getTotalLabel(Number(pagination?.total));

  if (!hasPreviousPage && !hasNextPage && currentPage <= 1 && !totalLabel) {
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        flexWrap: "wrap",
        marginTop: 20,
      }}
    >
      <div
        style={{
          color: "#1f2937",
          fontSize: "14px",
          fontWeight: 500,
        }}
      >
        หน้า {currentPage}
        {totalPages > 1 ? ` / ${totalPages}` : ""}
        {totalLabel ? ` • ${totalLabel}` : ""}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <button
          type="button"
          disabled={disabled || !hasPreviousPage}
          onClick={() => onPageChange(currentPage - 1)}
          style={{
            ...baseButtonStyle,
            opacity: disabled || !hasPreviousPage ? 0.5 : 1,
            cursor: disabled || !hasPreviousPage ? "not-allowed" : "pointer",
          }}
        >
          ก่อนหน้า
        </button>
        <button
          type="button"
          disabled={disabled || !hasNextPage}
          onClick={() => onPageChange(currentPage + 1)}
          style={{
            ...baseButtonStyle,
            opacity: disabled || !hasNextPage ? 0.5 : 1,
            cursor: disabled || !hasNextPage ? "not-allowed" : "pointer",
          }}
        >
          ถัดไป
        </button>
      </div>
    </div>
  );
};

export default GamePaginationControls;
